module.exports = __webpack_public_path__ + "static/media/404.aa7ad681.png";